import { render, staticRenderFns } from "./ExpandedView.vue?vue&type=template&id=45d63f73&scoped=true"
import script from "./ExpandedView.vue?vue&type=script&lang=js"
export * from "./ExpandedView.vue?vue&type=script&lang=js"
import style0 from "./ExpandedView.vue?vue&type=style&index=0&id=45d63f73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d63f73",
  null
  
)

export default component.exports